// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"VR","facetClass":"WR","tooltipWrapper":"XR","icon":"YR","tooltip":"ZR","content":"_R"};